(ns practitest.frontend.xbot.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::connected?
 (fn [db]
   (= :connected (get-in db [:xbot-backend :state]))))

(re-frame/reg-sub
 ::agents
 (fn [db]
   (:agents db)))

(re-frame/reg-sub
 ::view
 (fn [db]
   (get-in db [:options :view])))

(re-frame/reg-sub
 ::current-run
 (fn [db]
   (:current-run db)))

(re-frame/reg-sub
 ::run-status
 (fn [db]
   (get-in db [:options :run-status])))

(re-frame/reg-sub
 ::current-queue
 (fn [db]
   (let [running (vector (:jobs (first (:running db))))]
     (if (nil? (first running))
       (:queue db)
       (-> (:queue db)
           (update :jobs #(concat running %)))))))

(re-frame/reg-sub
 ::current-schedule
 (fn [db]
   (:schedule-queue db)))

(re-frame/reg-sub
 ::current-history
 (fn [db]
   (:history db)))

(re-frame/reg-sub
 ::current-telemetry
 (fn [db]
   (concat (get-in db [:options :run-telemetry])
           (:current-telemetry db))))

(re-frame/reg-sub
 ::remote?
 (fn [db [_ action]]
   (contains? (:remote db) action)))

(re-frame/reg-sub
 ::current-run-id
 (fn [db _]
   (get-in db [:options :run-id])))

(re-frame/reg-sub
 ::user-gravatars
 (fn [db _]
   (:user-gravatars db)))

(re-frame/reg-sub
 ::current-page
 (fn [db _]
   (:page db)))

(re-frame/reg-sub
 ::per-page
 (fn [db _]
   (:per-page db)))

(re-frame/reg-sub
 ::total-pages
 (fn [db _]
   (js/Math.ceil (/ (:total db) (:per-page db)))))

(re-frame/reg-sub
 ::pages
 (fn [db _]
   (let [npages ::total-pages]
     (range 1 (inc @npages)))))

(re-frame/reg-sub
 ::current-qm-tab
 (fn [db _]
   (:current-qm-tab db)))
